import colors from 'common/theme/saasModern/colors';
import styled from 'styled-components';
import { saasModernTheme } from 'common/theme/saasModern/index';

export const Container = styled.div`
  padding: 16px;
  width: 100%;
`;

export const ButtonLink = styled.button`
  border: none;
  background: transparent;
  text-align: start;
  cursor: pointer;
  color: ${({ active }) => (active ? colors.yellow : colors.primary)};
  text-decoration: ${({ active }) => (active ? 'underline' : 'none')};
  margin-top: 8px;
  @media (max-width: 767px) {
    font-size: 16px;
    width: 100%;
    margin-top: 6.4px;
  }
`;

export const Ul = styled.ul`
  padding: 8px 1.6px;
`;

export const Title = styled.h2`
  z-index: 5;
  max-width: 13ch;
  color: ${colors.primary};
  font-family:
    Gilroy,
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
  font-size: ${saasModernTheme.space[2]};
  font-weight: 700;
  position: relative;
  @media (max-width: 767px) {
    font-size: 24px;
  }
`;
